import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Scrollbar as ScrollbarCustom } from 'react-scrollbars-custom';

import './custom-scrollbar.scss';

export class Scrollbar extends React.PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
    ]),
    withOverflow: PropTypes.bool,
    onUpdate: PropTypes.func,
  };

  static defaultProps = {
    children: null,
    withOverflow: false,
    onUpdate: () => {},
  };

  scrollbar = React.createRef();

  render() {
    const { children, withOverflow } = this.props;

    const props = {
      ...this.props,
      onUpdate: (scrollValues, prevScrollValues) => {
        this.props.onUpdate(
          scrollValues,
          prevScrollValues,
          this.scrollbar.current,
        );
      },
    };
    delete props.withOverflow;

    return (
      <ScrollbarCustom
        ref={this.scrollbar}
        className={classnames('scrollbar-custom', {
          '_with-overflow': withOverflow,
        })}
        {...props}
      >
        {children}
      </ScrollbarCustom>
    );
  }
}
